/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Remove_Member_ButtonInputs */



/**
* | output |
* | --- |
* | "Remove from team" |
*
* @param {Team_Manager_Remove_Member_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_member_button = /** @type {((inputs?: Team_Manager_Remove_Member_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_Member_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer de l'équipe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aus dem Team entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi dal team")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить из команды")
	if (locale === "es") return /** @type {LocalizedString} */ ("Quitar del equipo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从团队中移除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームから削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम से हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover da equipa")
	return /** @type {LocalizedString} */ ("Remove from team")
});